<template>
  <b-sidebar
      id="add-new-user-sidebar"
      :visible="isAddNewUserSidebarActive"
      bg-variant="white"
      sidebar-class="sidebar-lg"
      shadow
      backdrop
      no-header
      right
      @hidden="resetForm"
      @change="(val) => $emit('update:is-add-new-user-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Add New {{ formConfig.entity }} with {{ defaultCreateObject }}
        </h5>

        <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
      >
        <b-form
            class="p-2"
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
        >
          <template v-for="config in configs ">
            <template v-if="config.name !== 'id'">
              <validation-provider
                  #default="validationContext"
                  :name="config.label"
                  :disabled="config.type === FieldType.TEXTAREA  ||config.type === FieldType.CK_IMAGE || config.type === FieldType.SWITCH || config.type === FieldType.HIDE"

              >
                <b-form-group :hidden="config.type === FieldType.HIDE" :label="config.label" :label-for="config.name">
                  <b-form-input v-if="config.type === FieldType.TEXT"
                                :id="config.name"
                                v-model="entity[config.name]"
                                :state="getValidationState(validationContext)"
                                trim
                  />
                  <b-form-input v-if="config.type === FieldType.PASSWORD"
                                :state="getValidationState(validationContext)"
                                :id="config.name"
                                type="password"
                                v-model="entity[config.name]"
                  />
                  <b-form-input v-if="config.type === FieldType.EMAIL"
                                :id="config.name"
                                v-model="entity[config.name]"
                  />
                  <b-form-input v-if="config.type === FieldType.NUMBER"
                                :id="config.name"
                                v-model="entity[config.name]"
                  />
                  <b-form-checkbox v-if="config.type === FieldType.SWITCH"

                                   :id="config.name"
                                   v-model="entity[config.name]"
                                   switch
                                   inline
                  />

                  <v-select v-if="config.type === FieldType.MULTIPLE"
                            v-model="entity[config.name]"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="config.refs.value"
                            :reduce="val => val.value"
                            multiple
                            :clearable="false"
                            :input-id="config.name"
                  />

                  <ckfinder
                      v-if="config.type === FieldType.CK_IMAGE"
                      :id="config.name"
                      v-model="entity[config.name]"
                      rows="3"
                  />


                  <b-form-textarea
                      v-if="config.type === FieldType.TEXTAREA"
                      :id="config.name"
                      v-model="entity[config.name]"
                      rows="3"
                  />
                  <v-select v-if="config.type === FieldType.SELECT_ARRAY"
                            v-model="entity[config.name]"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="config.refs.value"
                            :reduce="val => val"
                            :clearable="false"
                            :input-id="config.name"
                  />

                  <v-select v-if="config.type === FieldType.SELECT"
                            v-model="entity[config.name]"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="config.refs.value"
                            :reduce="val => val.value"
                            :clearable="false"
                            :input-id="config.name"
                  />

                  <flat-pickr v-if="config.type === FieldType.DATE"
                              v-model="entity[config.name]"
                              class="form-control"
                              :config="{ enableTime: true,dateFormat: 'Y-m-d H:i'}"
                  />


                  <prism-editor class="my-editor" v-if="config.type === FieldType.FREEMARKER"
                                v-model="entity[config.name]" :highlight="highlighter" line-numbers>


                  </prism-editor>


                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </template>
          </template>


          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
            >
              Add
            </b-button>
            <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
            >
              Cancel
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BFormCheckbox, BFormTextarea
} from 'bootstrap-vue'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {ref} from '@vue/composition-api'
import {required, alphaNum, email} from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import countries from '@/@fake-db/data/other/countries'
import store from '@/store'
import {FormConfig, FieldType} from "./index.d.ts";
import Ckfinder from '../../components/ckfinder/Ckfinder'
import {useToast} from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import Prism from 'vue-prism-component'
import {PrismEditor} from 'vue-prism-editor';
import {highlight, languages} from 'prismjs/components/prism-core';
// import 'prismjs/components/prism-clike';
// import 'prismjs/components/prism-markup-templating';

import 'prismjs/components/prism-markup.min';
import 'prismjs/themes/prism-twilight.css';
import 'vue-prism-editor/dist/prismeditor.min.css';

import flatPickr from 'vue-flatpickr-component'


export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormCheckbox,
    BFormTextarea,
    Ckfinder,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
    Prism,
    flatPickr,

    PrismEditor,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    defaultCreateObject: {
      type: Object,
      required: false,
    },

    formConfig: {
      type: FormConfig,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      countries,
    }
  },
  beforeUpdate() {
    console.log("before update call==");
  },

  setup(props, {emit}) {
    const configs = props.formConfig.configs
    let blankUserData = {}
    if (props.defaultCreateObject) {
      blankUserData = JSON.parse(JSON.stringify(props.defaultCreateObject));
    }

    let ety = JSON.parse(JSON.stringify(blankUserData))
    let highlighter = (code) => {

      return highlight(code, languages.markup, "html"); // languages.<insert language> to return html with markup

    }


    const toast = useToast();

    const r = {highlighter,};

    configs.forEach(config => {
      if (config.defaultValue != null) {
        ety[config.name] = config.defaultValue
      }
      if (config.action) {
        let ref = config.refs;
        r[config.name + "_ref"] = ref;
        store.dispatch(`${config.action}`)
            .then(response => {
              let res = [];
              response.data.data.forEach((f) => {
                res.push({label: f.name, value: f.id})
              })
              ref.value = res
            })
            .catch(error => {
              if (error.response.status === 404) {

              }
            })
      }
    })

    console.log(ety);

    const entity = ref(ety)

    console.log(entity)

    const resetuserData = () => {
      let val = JSON.parse(JSON.stringify(blankUserData));
      configs.forEach(config => {
        if (config.defaultValue != null) {
          val[config.name] = config.defaultValue
        }
      })
      entity.value = val
//      console.log(entity)
    }
    //   console.log(entity)

    const onSubmit = () => {


      console.log(entity.value)

      store.dispatch(`app-${props.formConfig.entity}/create${props.formConfig.entity}`, {body: entity.value})
          .then(() => {
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                title: `${props.formConfig.entity} Added`,
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            emit('refetch-data')
            emit('update:is-add-new-user-sidebar-active', false)

          }).catch((e) => {
        console.log(e);
        toast({
          component: ToastificationContent,
          props: {
            title: `Error create ${props.formConfig.entity}`,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      });
    }


    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetuserData)

    return {
      ...r,
//      defaultCreateObject,
      FieldType,
      entity,
      onSubmit,
      configs,
      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}

@import '@core/scss/vue/libs/vue-select.scss';
@import '~@core/scss/base/bootstrap-extended/variables';
@import 'bootstrap/scss/variables';
@import '~@core/scss/base/components/variables-dark';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

<style>
.height-200 {
  height: 200px
}

.my-editor {
  /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
  background: #2d2d2d;
  color: #ccc;

  /* you must provide font-family font-size line-height. Example:*/
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}

.my-editor pre {
  color: white;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
  outline: none;
}
</style>

